// extracted by mini-css-extract-plugin
export default {"howItWorks":"styles_howItWorks__ndc9d","howItWorksInner":"styles_howItWorksInner__BVmPp","steps":"styles_steps__4yW2V"};